<p-confirmDialog key="add" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<!--Form-->
<div class="MainGrid2Col">
	<label>Code:</label>
	<input [(ngModel)]="GuardianCD" class="form-control" type="text" placeholder="Code or Abbreviation" />

	<label>Description:</label>
	<input [(ngModel)]="GuardianDesc" class="form-control" type="text" placeholder="Name or Description" />
</div>

<!--Buttons-->
<div class="Buttons">
	<button class="btn btn-primary" (click)="onAdd()">Add</button>
	<button class="btn btn-primary" (click)="onClose()">Close</button>
</div>

<!--Error Message-->
<div class="TopMargin">
	<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
		{{ errorMessage }}
	</div>
</div>
